import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://gpngkwsgfwohtyenjaks.supabase.co";

const supabasePublishableKey = "sb_publishable_uacF6TEuA0dEmT0tgVz6vQ_VGT5zbFK";

export const supabase = createClient(supabaseUrl, supabasePublishableKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});
